import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import PauseIcon from '@mui/icons-material/Pause';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import DateRangeIcon from '@mui/icons-material/DateRange';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

import Datetime from 'components/Shared/Datetime';
import ArticleARisquePicto from 'components/Shared/ArticleARisquePicto';
import { ReclamationStatut } from 'constants.js';
import { TypePiece } from 'constants.js';

import { red, orange, grey, green } from '@mui/material/colors';

const styles = theme => ({
    root: {
        margin: theme.spacing(1, 0, 1, 0)
    },

    subHeader: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap'
    },

    typography: {
        marginRight: theme.spacing(3),
        display: 'flex',
        alignItems: 'center'
    },

    icon: {
        width: 19,
        height: 19,
        marginRight: theme.spacing(1)
    },

    statut0: {
        color: red[500]
    },

    statut1: {
        color: green[500]
    },

    statut2: {
        color: orange[500]
    },

    statut3: {
        color: grey[500]
    },

    statut4: {
        color: grey[500]
    },


    button: {
        paddingLeft: 0,
        marginRight: theme.spacing(3),
        color: grey[500]
    },
    leftIcon: {
        marginRight: theme.spacing(1)
    },
    rightIcon: {
        marginLeft: theme.spacing(1)
    },
    iconSmall: {
        fontSize: 19
    },
    typeCategorieQualification: {
        fontSize: '1.4rem'
    },
    depasse: {
        color: orange[500]
    }
});

class ReclamationPageHeader extends React.Component {

    getStatut() {

        switch (this.props.reclamation.statut) {

            case ReclamationStatut.Ouvert:
                return (<React.Fragment><AssignmentIcon className={this.props.classes.icon} /> Ouvert</React.Fragment>);
            case ReclamationStatut.EnCours:
                return (<React.Fragment><AssignmentIndIcon className={this.props.classes.icon} /> En cours</React.Fragment>);
            case ReclamationStatut.Reaffecte:
                return (<React.Fragment><PauseIcon className={this.props.classes.icon} /> Réaffecté</React.Fragment>);
            case ReclamationStatut.ClotureClient:
                return (<React.Fragment><AssignmentTurnedInIcon className={this.props.classes.icon} /> Clôture client</React.Fragment>);
            case ReclamationStatut.ClotureDefinitive:
                return (<React.Fragment><AssignmentTurnedInIcon className={this.props.classes.icon} /> Clôture définitive</React.Fragment>);

            default:
                return null;
        }
    }

    getClient() {
        const { reclamation } = this.props;

        if (reclamation.client !== null)
            return <React.Fragment>- {reclamation.client.libelle} ({reclamation.client.code})</React.Fragment>;

        return null;
    }

    render() {

        let { classes, reclamation, onClickSetVerificationDate, afficheVerification, templateReclamationPage, parent } = this.props;

        let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

        let nonLectureSeule = utilisateurCourant !== undefined && !utilisateurCourant.lectureSeule;

        const statutCloture = reclamation.statut === ReclamationStatut.ClotureClient || reclamation.statut === ReclamationStatut.ClotureDefinitive;

        let autoriseModificationDateVerification = nonLectureSeule && !statutCloture;

        let dateVerificationDepasse = reclamation.dateVerification && (new Date(reclamation.dateVerification) <= new Date());


        return (
            <div className={classes.root}>
                <Typography variant="h5" component="span" gutterBottom>
                    Dossier Après-Vente {parent ? 'parent ' : ''}{reclamation.id} {this.getClient()} - {reclamation.emetteur.nom} {reclamation.emetteur.prenom}
                    {reclamation.aRisque && <ArticleARisquePicto variant="badge" sx={{ ml: 1, verticalAlign: 'middle' }} />}
                </Typography>

                {templateReclamationPage && (
                    <Typography component="p" className={classes.typeCategorieQualification}>
                        <span id="reclamationType">{reclamation.type ? reclamation.type.libelle : ''}</span> / <span id="reclamationCategorie">{reclamation.categorie ? reclamation.categorie.libelle : ''}</span> / <span id="reclamationQualification">{reclamation.qualification ? reclamation.qualification.libelle : ''}</span>
                    </Typography>
                )}

                <div className={classes.subHeader}>
                    <Typography variant="caption" className={classNames(classes.typography, classes[`statut${reclamation.statut}`])}>
                        {this.getStatut()}
                    </Typography>

                    <Typography variant="caption" className={classes.typography}>
                        <DateRangeIcon className={classes.icon} />
                        <Datetime datetime={reclamation.dateCreation} withTooltip />
                    </Typography>

                    {reclamation.affectationGroupe && (
                        <Typography variant="caption" className={classes.typography}>
                            <span id="affectationGroupe">{reclamation.affectationGroupe && reclamation.affectationGroupe.libelle}</span> {reclamation.affectationUtilisateur && reclamation.affectationUtilisateur.nom ? ` / ` : ''} <span id="affectationUtilisateur">{reclamation.affectationUtilisateur && reclamation.affectationUtilisateur.nom ? reclamation.affectationUtilisateur.nom : ''}</span>
                        </Typography>
                    )}

                    {!templateReclamationPage && (
                        <Typography variant="caption" className={classes.typography}>
                            {reclamation.type ? reclamation.type.libelle : ''} / {reclamation.categorie ? reclamation.categorie.libelle : ''} / {reclamation.qualification ? reclamation.qualification.libelle : ''}
                        </Typography>
                    )}

                    {reclamation.piece && reclamation.typePiece === TypePiece.Commande && (
                        <Typography variant="caption" className={classes.typography}>
                            Concerne la commande {reclamation.piece.numeroPiece}
                        </Typography>
                    )}

                    {reclamation.piece && reclamation.typePiece === TypePiece.DemandeTransfert && (
                        <Typography variant="caption" className={classes.typography}>
                            Concerne la demande de transfert {reclamation.piece.numeroPiece}
                        </Typography>
                    )}

                    {reclamation.piece && reclamation.typePiece !== TypePiece.Commande && reclamation.typePiece !== TypePiece.DemandeTransfert && (
                        <Typography variant="caption" className={classes.typography}>
                            Concerne la pièce {reclamation.piece.numeroPiece}
                            {reclamation.piece.numeroPreparation && reclamation.piece.numeroPreparation !== reclamation.piece.numeroPiece
                                ? ` - ${reclamation.piece.numeroPreparation}`
                                : ''}
                        </Typography>
                    )}

                    {reclamation.litige && (
                        <Typography variant="caption" className={classes.typography}>
                            Concerne le litige {reclamation.litige.cle} sur la facture {reclamation.litige.facture}
                        </Typography>
                    )}

                    {afficheVerification === true &&
                        <Button disabled={!autoriseModificationDateVerification} onClick={onClickSetVerificationDate} variant="text" size="small" className={classNames(classes.button, { [classes.depasse]: dateVerificationDepasse })}>
                            <EventAvailableIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
                            <Datetime datetime={reclamation.dateVerification} withTime={false} placeholder="Pas de vérification planifiée" />
                        </Button>
                    }

                    {reclamation.packingList && (
                        <Typography variant="caption" className={classes.typography}>
                            <LocalShippingIcon className={classes.icon} />
                            Packing list #{reclamation.packingList.id}
                        </Typography>
                    )}

                </div>
            </div>
        );
    }
}

ReclamationPageHeader.protoTypes = {
    reclamation: PropTypes.object.isRequired,
    onClickSetVerificationDate: PropTypes.func.isRequired,
    afficheVerification: PropTypes.bool,
    templateReclamationPage: PropTypes.bool.isRequired,
    parent: PropTypes.bool
};

export default withStyles(styles)(ReclamationPageHeader);